const styles = theme => ({
  formControl: {
    minWidth: 380,
    maxWidth: 380,
  },
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [`@media (max-width: 1440px)`]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '8px',
    },
    [`@media (max-width: 1024px)`]: {},
  },
})

export default styles
